if (!customElements.get('td-pdp-responsibly-made')) {
  class TdPdpResponsiblyMade extends HTMLElement {
    connectedCallback() {
      this.carousel = this.querySelector('.td-pdp-rm__carousel');
      if (!this.carousel) return;
      this.query = window.matchMedia('(min-width: 1000px)');
      this.onBreakpoint = this.sync.bind(this);
      this.query.addEventListener('change', this.onBreakpoint);
      this.initWhenReady();
    }

    disconnectedCallback() {
      if (this.query) this.query.removeEventListener('change', this.onBreakpoint);
      this.destroy();
      if (this.readyTimer) clearTimeout(this.readyTimer);
    }

    sync() {
      if (this.query.matches) {
        this.destroy();
      } else if (!this.swiper) {
        this.build();
      }
    }

    destroy() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    build() {
      const prevEl = this.querySelector('[data-td-rm-prev]');
      const nextEl = this.querySelector('[data-td-rm-next]');
      const scrollbarEl = this.querySelector('.td-pdp-rm__progress');
      const config = {
        slidesPerView: 'auto',
        spaceBetween: 16,
        slidesOffsetBefore: 10,
        slidesOffsetAfter: 10,
        grabCursor: true,
        watchOverflow: true,
        longSwipesRatio: 0.15
      };
      if (prevEl && nextEl) {
        config.navigation = { prevEl: prevEl, nextEl: nextEl, disabledClass: 'td-pdp-rm__arrow--disabled' };
      }
      if (scrollbarEl) {
        config.scrollbar = { el: scrollbarEl, draggable: true };
      }
      this.swiper = new window.Swiper(this.carousel, config);
    }

    initWhenReady(attempts) {
      if (typeof window.Swiper !== 'function') {
        const tries = attempts || 0;
        if (tries < 100) this.readyTimer = setTimeout(() => this.initWhenReady(tries + 1), 50);
        return;
      }
      this.sync();
    }
  }

  customElements.define('td-pdp-responsibly-made', TdPdpResponsiblyMade);
}
